module.exports = __webpack_public_path__ + "static/media/background6.3415f69b.jpg";